import styled, { css } from 'styled-components';

export const Bold = styled.span(
  ({ theme: { palette } }) => css`
    text-transform: uppercase;
    font-weight: 700;
    color: ${palette.grey[900]};
  `,
);
